import { useMemo } from 'react';

import DraggableEnergy from '@/components/game/3d/physics/DraggableEnergy';
import { getColorfromChar } from '@/util/season';

const EnergyBuilderDonation = ({
	energyArr,
	playerId,
	rotato = 0,
	initPos = [12, 5, 16],
	type = 'donation',
}) => {
	if (energyArr == null || energyArr.length <= 0) return null;

	function randomPos() {
		return Math.floor(Math.random() * 1.5) - 1.5;
	}

	const energyObjects = useMemo(() => {
		const energies: any[] = [];

		for (let i = 0; i < energyArr.length; i++) {
			const energyColor = energyArr[i];
			const color = getColorfromChar(energyColor);

			const homePosition: [number, number, number] = [
				initPos[0] + randomPos(),
				initPos[1] + 5 + energyArr.length * 1.2,
				initPos[2] + randomPos(),
			];

			energies.push({
				id: `${playerId}-${type}-${energyColor}-${i}`,
				color,
				energyColor,
				type,
				homePosition,
			});
		}

		return energies;
	}, [energyArr]);

	const energyDisplay = energyObjects.map((energyObj) => (
		<DraggableEnergy
			key={energyObj.id}
			energy={energyObj}
			rotato={rotato}
		/>
	));

	return (
		<group key={`${type}_energy_group_${playerId}`}>{energyDisplay}</group>
	);
};

export default EnergyBuilderDonation;
